import React from 'react';
import {
  Box,
  Divider,
  Flex,
  Link,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useTranslation, Trans } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { useBoxTargetUserGroups } from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { DlpPolicyItem } from '@Policy/utils/types';

export const TargetUserGroupsBox = () => {
  const props = useBoxTargetUserGroups();
  useWhyDidYouUpdate('TeamsTargetUserGroups', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const TargetUserGroupsBoxShareLink = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const syncTargets = contextSelector((s) => s.syncUsersByService);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return (
    <Flex direction="column">
      <Flex height="32px" alignItems="center">
        <Text fontSize="14px" lineHeight="20px">
          {t('policy.policyTarget.box.allUserGroups')}
        </Text>
      </Flex>
      <Flex mt="16px" whiteSpace="pre-wrap">
        <Text color={colorStyle.color.primary}>
          <Trans i18nKey="policy.text.generalDownClick">
            <Link onClick={syncTargets}>placeholder</Link>
            placeholder
          </Trans>
        </Text>
      </Flex>
    </Flex>
  );
};

const General = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  const policySubType = policySelector((s) => s.policySubType);
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={false}
        rmsEnabledShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        {policySubType === 1 ? (
          <TargetUserGroupsBoxShareLink />
        ) : (
          <TargetUserGroupsBox />
        )}
      </Flex>
    </Box>
  );
};
export default React.memo(General);
